import { generateMaaranToken } from '@/utils/easygtm'
import { useQuery } from '@tanstack/react-query'

export default function useGenerateMaaranToken(isEnabled) {
    
  const {data, isLoading} = useQuery({
    queryKey: ['maaran-api-token'],
    queryFn: generateMaaranToken,
    enabled: !!isEnabled,
    staleTime: 10 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  return {data, isLoading}

}
